import React, { useState } from 'react';

const WINDOWS = ["All", "Past 10", "Past 5"];

// Teal shade: low pct = pale teal, high pct = deep teal
function tealShade(pct) {
  const t = Math.min(pct / 0.25, 1);
  const r = Math.round(153 + (4   - 153) * t);
  const g = Math.round(246 + (47  - 246) * t);
  const b = Math.round(228 + (46  - 228) * t);
  return `rgb(${r},${g},${b})`;
}

// Orange shade: low pct = pale orange, high pct = deep orange
function orangeShade(pct) {
  const t = Math.min(pct / 0.25, 1);
  const r = Math.round(254 + (124 - 254) * t);
  const g = Math.round(215 + (45  - 215) * t);
  const b = Math.round(170 + (18  - 170) * t);
  return `rgb(${r},${g},${b})`;
}

export default function StyleBreakdown({ breakdowns, fighterName, side }) {
  const [activeWindow, setActiveWindow] = useState("All");

  if (!breakdowns || Object.keys(breakdowns).length === 0) {
    return <div className="breakdown-empty">No style data available</div>;
  }

  const data    = breakdowns[activeWindow] || breakdowns["All"] || [];
  const sorted  = [...data].sort((a, b) => b.percentage - a.percentage);
  const isF2    = side === "f2";
  const accent  = isF2 ? "var(--orange)" : "var(--teal)";
  const colorFn = isF2 ? orangeShade : tealShade;

  return (
    <div className="breakdown">
      <div className="breakdown-name" style={{ color: accent }}>
        {fighterName}
      </div>

      <div className="breakdown-tabs">
        {WINDOWS.map(w => (
          <button
            key={w}
            className={`breakdown-tab ${activeWindow === w ? "active" : ""}`}
            style={activeWindow === w ? { borderColor: accent, color: accent } : {}}
            onClick={() => setActiveWindow(w)}
          >
            {w}
          </button>
        ))}
      </div>

      <div className="breakdown-bars">
        {sorted.map(({ cluster, percentage }) => {
          const color = colorFn(percentage);
          const pct   = (percentage * 100).toFixed(1);
          const barW  = Math.min((percentage / 0.25) * 100, 100);

          return (
            <div key={cluster} className="breakdown-row">
              <div className="breakdown-label">{cluster}</div>
              <div className="breakdown-track">
                <div
                  className="breakdown-fill"
                  style={{ width: `${barW}%`, background: color }}
                />
              </div>
              <div className="breakdown-pct" style={{ color }}>
                {pct}%
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
